import { useState } from 'react';

export const useFilterData = <TFilterData,>() => {
  const [filterData, setFilterData] = useState<TFilterData | null>(null);

  return { filterData, setFilterData };
};

export type FilterData<TFilterData> = ReturnType<
  typeof useFilterData<TFilterData>
>['filterData'];

export type FilterDataSetter<TFilterData> = ReturnType<
  typeof useFilterData<TFilterData>
>['setFilterData'];
